import React, { useState } from "react";
import Sidebar from "./Sidebar";
import CompanyWrapper from "./CompanyWrapper";
import ContentSections from "../../../libraries/content-section";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

const TableOfContents = ({ tabs, activeHeader, activeColor }) => {
  const [matched, activeUntil] =
    activeHeader === null
      ? [false, -1]
      : tabs.reduce(
          ([isMatched, matchedOffset], { id }, offset) => {
            if (isMatched) return [isMatched, matchedOffset];
            if (id === activeHeader) return [true, offset];
            return [false, -1];
          },
          [false, -1]
        );

  return (
    <div className="col-span-12 md:col-span-1 ml-8">
      <div className="sticky top-[95px] hidden lg:block">
        <ul
          className="mt-2 border-l-2 lg:mt-4 lg:space-y-4"
          style={{ borderColor: activeColor }}
        >
          {tabs.length > 0 &&
            tabs.map(({ id, name }, offset) => (
              <li key={id} className="flex items-center relative">
                {offset === 0 && (
                  <div className="absolute h-1/2 w-4 top-0 -left-2 bg-white z-10"></div>
                )}
                {offset === tabs.length - 1 && (
                  <div className="absolute h-1/2 w-4 bottom-0 -left-2 bg-white z-10"></div>
                )}
                <div
                  style={{
                    borderColor: activeColor,
                    backgroundColor:
                      matched && offset <= activeUntil ? activeColor : "white"
                  }}
                  className={`shrink-0 rounded-full w-3 h-3 border-2 -ml-[7px] z-20`}
                ></div>
                <a
                  href={`#${id}`}
                  style={{
                    color:
                      matched && offset <= activeUntil ? activeColor : "#6B7280"
                  }}
                  className={`font-semibold grow px-2 pl-4 pr-2 space-x-2 hover:text-gray-900`}
                >
                  {name}
                </a>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

const PageContent = ({
  name,
  description,
  applyUrl,
  job,
  sections,
  colorButtonBg,
  colorButtonText,
  colorHighlightBg,
  colorHighlightText,
  colorHighlightIcon,
  colorSectionHeaderText,
  colorSectionText,
  companyImageGallery,
  hiringManager,
  team,
  values,
  hiringProcess,
  tabs
}) => {
  const [activeHeader, setActiveHeader] = useState(null);

  return (
    <>
      <div className="container">
        <div className="md:flex md:space-x-4 xl:space-x-8">
          <div className="w-full md:w-[250px] xl:w-[384px] h-max md:sticky md:top-4">
            <Sidebar
              job={job}
              colorHighlightText={colorHighlightText}
              colorHighlightIcon={colorHighlightIcon}
              backgroundColor={colorHighlightBg}
            />
            <TableOfContents
              tabs={tabs}
              activeHeader={activeHeader}
              activeColor={colorHighlightIcon}
            />
          </div>

          <div className="flex-1 w-full max-w-full md:w-[calc(100%-264px)] xl:w-[calc(100%-384px)]">
            <div className="space-y-4 xl:space-y-8">
              <ContentSections
                sections={sections}
                colorSectionHeaderText={colorSectionHeaderText}
                colorSectionText={colorSectionText}
                setActiveHeader={setActiveHeader}
                colorHighlightText={colorHighlightText}
              />

              <section>
                <CompanyWrapper
                  name={name}
                  description={description}
                  companyImageGallery={companyImageGallery}
                  hiringManager={hiringManager}
                  team={team}
                  values={values}
                  hiringProcess={hiringProcess}
                  colorSectionHeaderText={colorSectionHeaderText}
                  colorSectionText={colorSectionText}
                  colorHighlightBg={colorHighlightBg}
                  setActiveHeader={setActiveHeader}
                />
              </section>

              <section>
                <div className="mb-6">
                  <a
                    href={applyUrl}
                    className="w-full max-w-full lg:w-auto text-base flex justify-center items-center px-[18px] py-2.5 text-white border border-solid rounded-lg font-medium shadow-xs block"
                    style={{
                      color: colorButtonText,
                      backgroundColor: colorButtonBg
                    }}
                  >
                    Apply Now
                    <ChevronRightIcon className="h-5 w-5 inline-block" />
                  </a>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageContent;
